/**
 * Tahsilat ekranının üç tipi için başlık/alt başlık/ikon.
 *
 * Tip `?type=` sorgu parametresinden gelir (normal | account | invoice) ve hem sayfa
 * başlığı hem de `PayerInfoSection` içindeki bölüm başlığı buradan beslenir — iki yerde
 * ayrı ayrı yazılsaydı biri değişip diğeri unutulabilirdi.
 *
 * Adlandırma kuralı KORUNUR:
 *  - Cari rolündeki kullanıcı için "Tahsilat" değil "Ödeme" denir.
 *  - `account` tipinde süper admin "Firma", diğer roller "Cari/Bayi" görür.
 * Bu ayrım ürün kararıdır; ekran tasarımı iki durumda da aynıdır.
 */
export const getPaymentTypeMeta = (urlType, { isAccountRole = false, isStaffAdmin = false } = {}) => {
    const actionWord = isAccountRole ? 'Ödeme' : 'Tahsilat';

    if (urlType === 'account') {
        const who = isStaffAdmin ? 'Firma' : 'Cari/Bayi';
        return {
            title: `${who} ile ${actionWord}`,
            subtitle: `${who} seçip kart bilgileri ile ${actionWord.toLowerCase()} alın.`,
            icon: 'bx-building-house',
            stepLabel: `${who} Bilgileri`,
        };
    }

    if (urlType === 'invoice') {
        return {
            title: `Fatura Bilgisi ile ${actionWord}`,
            subtitle: `Fatura bilgilerini girerek kart ile ${actionWord.toLowerCase()} yapın.`,
            icon: 'bx-file',
            stepLabel: 'Fatura Bilgileri',
        };
    }

    return {
        title: `Anlık ${actionWord}`,
        subtitle: `Kart bilgilerini girerek ${actionWord.toLowerCase()}ı anında alın.`,
        icon: 'bx-bolt-circle',
        stepLabel: null, // Anlık tipte ayrı bir bilgi adımı yok
    };
};
